import request from '../utils/request'

export function getActivityParticipationRegions() {
  return request({
    url: '/api/admin/activity-participation/regions',
    method: 'get'
  })
}

export function getActivityParticipationEvents(params) {
  return request({
    url: '/api/admin/activity-participation/events',
    method: 'get',
    params
  })
}

export function getActivityParticipationEvent(id) {
  return request({
    url: `/api/admin/activity-participation/events/${id}`,
    method: 'get'
  })
}

export function createActivityParticipationEvent(data) {
  return request({
    url: '/api/admin/activity-participation/events',
    method: 'post',
    data
  })
}

export function updateActivityParticipationEvent(id, data) {
  return request({
    url: `/api/admin/activity-participation/events/${id}`,
    method: 'put',
    data
  })
}

export function publishActivityParticipationEvent(id) {
  return request({
    url: `/api/admin/activity-participation/events/${id}/publish`,
    method: 'post'
  })
}

export function offlineActivityParticipationEvent(id) {
  return request({
    url: `/api/admin/activity-participation/events/${id}/offline`,
    method: 'post'
  })
}

export function getActivityParticipationRegistrations(params) {
  return request({
    url: '/api/admin/activity-participation/registrations',
    method: 'get',
    params
  })
}

export function acceptActivityParticipationRegistration(id, data) {
  return request({
    url: `/api/admin/activity-participation/registrations/${id}/accept`,
    method: 'post',
    data
  })
}

export function rejectActivityParticipationRegistration(id, data) {
  return request({
    url: `/api/admin/activity-participation/registrations/${id}/reject`,
    method: 'post',
    data
  })
}
